export const defaultBookingWindowInDays = 14;
export const maxBookingWindowCapInDays = 365;

/**
 * Largest booking window across a set of courses, capped at a year.
 *
 * `Math.max()` of an empty list is `-Infinity`, and a non-finite day count never returns from
 * `CalendarDate.add()`, so a bookable facility with no available courses falls back to the default.
 */
export function maxBookingWindowInDays(courses: ReadonlyArray<{ bookingWindowInDays: number }>): number {
	const days = Math.min(Math.max(...courses.map((course) => course.bookingWindowInDays)), maxBookingWindowCapInDays);
	return Number.isFinite(days) ? days : defaultBookingWindowInDays;
}
